import React, { Component } from 'react';
import { Link, NavLink} from 'react-router-dom';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from 'react-loader-spinner';
import '../../common/restaurant.scss';
import {getData,getListData} from '../../../services/index';

import {Redirect} from 'react-router-dom';

import $ from 'jquery';

class Home extends Component {
	constructor(props) {
        super(props);
		var storedArray = JSON.parse(localStorage.getItem("userData"));
		this.state = {
			name: storedArray['data']['name'],
			mobile: storedArray['data']['mobile'],
            user_id: storedArray['data']['user_id'],
			id: this.props.match.params.id,
			
		};
		if(!localStorage.getItem('userData')) {
		this.props.history.push("login");
		}	
		this.logout = this.logout.bind(this);
		this.addadress = this.addadress.bind(this);
		this.onChange = this.onChange.bind(this);
		this.handleChange = this.handleChange.bind(this);
	}
	handleChange(event) {
	  this.setState({
		tag: event.target.value
	  });
	}
	
	addadress() {
		if(this.state.name || this.state.mobile){
            var storedArray = JSON.parse(localStorage.getItem("userData"));
            this.state.user_id = storedArray['data']['user_id'];
            this.state.id = this.props.match.params.id;
            this.state.type = 'car';
			getListData('Buycar/car_enquiry',this.state).then((result) => {
			if(result.status==400){
				document.getElementById('alert').innerHTML='<div class="alert alert-warning" role="alert"><i class="fa fa-info-circle" aria-hidden="true"></i> 1 Please insert all fields</div>';
			}
			else{
				document.getElementById('alert').innerHTML='';
			}
			this.setState({redirectToReferrer: true});
				
			});
		}
		if(this.state.name=='' || this.state.mobile==''){
			document.getElementById('alert').innerHTML='<div class="alert alert-warning" role="alert"><i class="fa fa-info-circle" aria-hidden="true"></i> 0 Please insert all fields </div>';
		}
		else{
			document.getElementById('alert').innerHTML='';
		}
	}

	onChange(e){
		this.setState({[e.target.name]:e.target.value});
	}

    componentDidMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		
	$('.float-label-1 .form-control-1[placeholder]').each(function () {
		if ($(this).attr('placeholder').length > 0) { $(this).addClass('active');}
	});
	$('.float-label-1 .form-control-1[value]').each(function () {
		if ($(this).val.length > 0) { $(this).addClass('active');}
	});
	$('.float-label-1 .form-control-1').on('blur', function () {
		if ($(this).val().length > 0) { $(this).addClass('active');} else {
			if ($(this)[0].hasAttribute('placeholder') === true) {
				if ($(this).attr('placeholder').length > 0) { $(this).addClass('active');} 
				else { $(this).removeClass('active');}
			} else { $(this).removeClass('active');}
		}
	});
	if (localStorage.getItem('userData')){
	var storedArray = JSON.parse(localStorage.getItem("userData"));
	document.getElementById("name").value = storedArray['data']['name'];
	document.getElementById("mobile").value = storedArray['data']['mobile'];
	
	
	document.getElementById("name").classList.add("active");
	document.getElementById("mobile").classList.add("active");
	
	
	
	
	
	}
	}
	logout(){
	localStorage.setItem("userData",'');
	localStorage.clear();
	this.props.history.push("login");
	}

	render() {
	
	if (this.state.redirectToReferrer ){
		return (<Redirect to={'/thank_you'}/>)
		}
	
		return (
			<div>
                
				
                 
                {/*Home Section End*/}

                {/*collection banner*/}
                <section className="pb-0 margin-pd mt-45 restro">
					<div className="_2u0oK _1iY8Y">
						
						   <div className="_3TzfO page_head">
							  <div className="_2QN4q">
								 <Link to={`${process.env.PUBLIC_URL}/car_details/${this.state.id}`}>
								 <img src={`${process.env.PUBLIC_URL}/assets/images/icon/return_white.png`} alt="" /></Link>
							  </div>
							  <div className="_1leRb page_title">
								Car Enquiry
							  </div>
							  <div className="b5NJg"></div>
						   </div>
						   <input type="submit" hidden=""/>
						
					 </div>
				    
                </section>
				
				 {/*collection banner*/}
                <section className="pb-0 margin-pd restro mt-45 details-pad-top-n">
				    <div className="res-details-div" role="button" tabIndex="0">
						<div className="res-details-info">
							<div className="details-dish-con">
								<div className="col-md-12">
									<div className="wrap-login200">
										<form className="login100-form validate-form">
											<div className="form-group-1 float-label-1 validate-input" data-validate="Enter Name">
												<input type="text" className="form-control-1" name="name" id="name" autoComplete="off" onChange={this.onChange}/>
												<label className="color"> Name</label>
											</div>
											<div className="form-group-1 float-label-1 validate-input" data-validate="Enter Mobile No.">
												<input type="text" className="form-control-1" name="mobile" id="mobile" autoComplete="off" onChange={this.onChange}/>
												<label className="color"> Mobile No.</label>
											</div>
											
											
											
											<div id="alert" className="m-b-10"></div>
											
											<div className="container-login100-form-btn">				
												<input type="button"  className="login100-form-btn" value="Send Enquiry" onClick={this.addadress}/>
											</div>	
											
										</form>
									</div>
								</div>		
							</div>
						</div>
					</div>
                </section>
				
				
				 
				


 
			</div>
			
			)

	}
}

export default Home;
